import classNames from "classnames";
import * as React from "react";

import { Avatar } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { getTeamAgents } from "helpers/team";
import { IAgent } from "store/entities/agents";
import { ITeam } from "store/entities/teams";

import { TeamMembers } from "./TeamMembers";
import { TeamProfile } from "./TeamProfile";

interface IProps {
  agents: IAgent[];
  team: ITeam;
  isSelected: boolean;
  handleTeamSelect(team: ITeam): void;
  handleTeamDoubleClick(team: ITeam): void;
}

export const TeamsRow: React.FC<IProps> = ({ agents, team, isSelected, handleTeamSelect, handleTeamDoubleClick }) => (
  <tr
    key={team.id}
    className={classNames("selectable", {
      selected: isSelected,
    })}
    onClick={() => handleTeamSelect(team)}
    onDoubleClick={() => handleTeamDoubleClick(team)}
  >
    <td>
      <div className="selected-mark" />
      <Flex alignItems="center" justifyContent="center">
        <Avatar type="text" text={team.name} shape="rounded-square" size="large" css={{ minWidth: "40px" }} />
      </Flex>
    </td>
    <td>
      <TeamProfile isDefault={team.isDefault} name={team.name} agentsCount={team.agentIds.length} />
    </td>
    <td>
      <TeamMembers agents={getTeamAgents(team, agents)} />
    </td>
  </tr>
);
